// Modal.js

import React, {  useState } from "react";
import { useTranslation } from "react-i18next";
import { Spell } from "../../Types/TableTypes";
import SpellModalEdit from "./SpellModalEdit";
import SpellModalView from "./SpellModalView";
import AllSpellsProvider from "../../Context/AllSpellsContext";

interface SpellEditDetailProps{
    editMode: boolean,
    isNewSpell: boolean,
    spellGroup:{
        label: string,
        hasSlotsGroup: boolean,
        hasSlotsEach: boolean,
        remainingSlots: number,
        maxSlots: number,
        list: Spell[]
    }
    spell: Spell,
    updateSpell: (spell: Spell)=> void,
    deleteSpell: ()=> void
}

const SpellItemComponent = (props: SpellEditDetailProps) => {
    const [isModalOpen, setIsModalOpen] = useState (false);
    const { t } = useTranslation();
    
    return (
        <>
            {!props.isNewSpell && <button type="button" className="btn btn-link" onClick={e=>{
                setIsModalOpen(true)}}>
                    {props.spell.name}
                </button>}
            {props.isNewSpell && 
                <span role="button" onClick={e=>{  
                    setIsModalOpen(true);
                    }}>
                    <span>{t("spell-newspell")}&nbsp;<i className="bi bi-plus-circle"></i></span>
                </span>
            }
            {isModalOpen && props.editMode && 
                <SpellModalEdit
                    closeModal={closeModal}
                    spell={props.spell}
                    updateSpell={props.updateSpell}
                    deleteSpell={props.deleteSpell}
                ></SpellModalEdit>
            }
            {isModalOpen && !props.editMode && 
                <SpellModalView
                    closeModal={closeModal}
                    // allSpells={props.allSpells}
                    spell={props.spell}
                    // updateSpell={props.updateSpell}
                    // deleteSpell={props.deleteSpell}
                ></SpellModalView>
            }
        </>
    );

    function closeModal(){
        setIsModalOpen(false);
    }
    
};

export default SpellItemComponent;
